import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { faBook } from "@fortawesome/pro-light-svg-icons";

import docs from "../../../../../../docs/directory.json";

export default function Documentation({ nodeType }: { nodeType: string }) {
  if (!(nodeType in docs.planNodes)) {
    return null;
  }
  const nodeDocs = docs.planNodes[nodeType as keyof typeof docs.planNodes];
  return (
    <div className="my-1">
      <FontAwesomeIcon className="text-gray-500" icon={faBook} />{" "}
      {nodeDocs.shortDescription}{" "}
      <a target="_blank" href={`https://pganalyze.com` + nodeDocs.path}>
        <FontAwesomeIcon icon={faUpRightFromSquare} />
      </a>
    </div>
  );
}
